let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3IIaq")).then(() => parcelRequire('8MoYY'));